import { RootState } from 'store';
import {
  BaseQueryFn,
  FetchArgs,
  createApi,
  fetchBaseQuery,
  FetchBaseQueryError,
} from '@reduxjs/toolkit/query/react';
import { toast } from 'react-toastify';
import { deleteTokenAuth } from 'store/auth';
import { env } from "config/env";

export interface ApiResponseI<T> {
  data: T;
}

export interface ApiErrorResponseI {
  message: string;
  statusCode: number;
}

export const baseQuery = fetchBaseQuery({
  baseUrl: env.REST_HOST,
  prepareHeaders: (
    headers,
    { getState, endpoint },
  ) => {

    const token =
      (getState() as RootState)
        .auth.accessToken;

    if (token) {
      headers.set(
        "Authorization",
        `Bearer ${token}`,
      );
    }

    // Skip default Content-Type for uploads/imports to let browser set multipart boundary correctly
    if (endpoint.toLowerCase().includes('upload') || endpoint.toLowerCase().includes('import')) {
      return headers;
    }

    if (!headers.has('Content-Type')) {
      headers.set('Content-Type', 'application/json');
    }

    return headers;
  },
});

const baseQueryWithInterceptor: BaseQueryFn<
  string | FetchArgs,
  unknown,
  FetchBaseQueryError
> = async (args, api, extraOptions) => {
  let adjustedArgs = typeof args === "string" ? { url: args } : { ...args };

  let result = await baseQuery(adjustedArgs, api, extraOptions);

  if (result.error) {
    if (result.error.status === 401) {
      toast("Please re-login for continue process");
      api.dispatch(deleteTokenAuth());
    }
    // showToast((result.error.data as ApiErrorResponseI).message || 'Unknown Error');
  }

  if (process.env.NODE_ENV === "development") {
    console.info("[RTK Api result]:", result);
  }

  return result;
};

export const Api = createApi({
  baseQuery: baseQueryWithInterceptor,
  reducerPath: "api",
  keepUnusedDataFor: 0.1,
  tagTypes: [
    "VehicleAuxiliary",
    "VehicleType",
    "FreezerModel",
    "VehicleModel",
    "FuelType",
    "TripType",
    "DistanceType",
    "WaitingTimeRate",
    "TripDaysThreshold",
    "DriverAllowance",
    "VehicleOperation",
    "Vendor",
    "Customer",
    "Fleet",
    "Driver",
    "Country",
    "State",
    "City",
  ],
  endpoints: () => ({}),
});
